import firebase from "firebase/app";
import "firebase/functions";
import "firebase/auth";
import "firebase/firestore";

import { ActionContext } from "vuex";
import { RootState } from "../store/types";
import { api as userApi } from "../store/modules/user";
import { UserState } from "../store/modules/user/types";
import { CALC_REGION } from "@dokogd/shared";

let firebaseApp: firebase.app.App | null = null;
const firebaseConfig = {
  apiKey: "AIzaSyA0RHRe8n9TRtb77wj18kSp7y99vva-2LQ",
  authDomain: "doko-goes-digital.firebaseapp.com",
  databaseURL: "https://doko-goes-digital.firebaseio.com",
  projectId: "doko-goes-digital",
  storageBucket: "doko-goes-digital.appspot.com",
  messagingSenderId: "93779179432",
  appId: "1:93779179432:web:f3a55ec6a9e0e575894f9d",
};
export async function currentApp(
  context?: ActionContext<UserState, RootState>
): Promise<firebase.app.App> {
  return new Promise<firebase.app.App>(resolve => {
    if (firebaseApp === null) {
      // Initialize Firebase
      firebaseApp = firebase.initializeApp(firebaseConfig);
      if (process.env.NODE_ENV === "development") {
        console.log("use local function");

        firebaseApp.functions(CALC_REGION).useEmulator("localhost", 5001);
        /*
        firebaseApp.firestore().settings({
          ignoreUndefinedProperties: true,
          host: "localhost:5000",
          ssl: false,
        });
        firebaseApp.auth().useEmulator("http://localhost:9099");
        */
      }
      if (context) {
        const initializedApp = firebaseApp;
        const clearUser = userApi.mutations.CLEAR_USER;
        const setUser = userApi.mutations.SET_USER;
        context.commit(clearUser);
        firebaseApp.auth().onIdTokenChanged(user => {
          resolve(initializedApp);
          if (user) {
            context.commit(setUser, user.toJSON());
          } else {
            context.commit(clearUser);
          }
        });
      }
    } else {
      resolve(firebaseApp);
    }
  });
}

function writeLog(msg: string) {
  console.log(msg);
  const log: string[] = JSON.parse(localStorage.getItem("DEBUG_LOG") ?? "[]");
  let data = [...log, msg];

  if (data.length > 100) {
    const [old, ...next] = data;
    console.log("Discard Log", old);
    data = next;
  }
  localStorage.setItem("DEBUG_LOG", JSON.stringify(data));
}

async function logger(name: string) {
  const app = await currentApp();
  const start = new Date().toISOString();
  const userId = app.auth().currentUser?.uid ?? "--";
  const displayName = app.auth().currentUser?.displayName ?? "--";

  return {
    error: (msg: string, duration: number) => {
      writeLog(
        `[ERROR]\t${userId}<${displayName}>\t${name}\t${start}\t${duration}\t${msg}`
      );
    },
    log: (instanceId: string, count: number, duration: number) => {
      writeLog(
        `[INFO]\t${userId}<${displayName}>\t${name}\t${start}\t${duration}\t${instanceId}\t${count}`
      );
    },
  };
}

export async function createHttpFunction(name: string) {
  const f = (await currentApp()).functions(CALC_REGION).httpsCallable(name);
  const res: firebase.functions.HttpsCallable = async (data?: any) => {
    const l = await logger(name);
    const t0 = performance.now();
    try {
      const httpRes = await f(data);
      console.log(httpRes);
      const t1 = performance.now();
      l.log(httpRes.data.instanceId, httpRes.data.count, t1 - t0);
      return httpRes;
    } catch (err) {
      const t1 = performance.now();
      l.error(`${err}`, t1 - t0);
      throw err;
    }
  };
  return res;
}
